import { AppRouter } from './AppRouter';
import { BrowserRouter } from 'react-router-dom';

import {
    ResponsiveContextProvider,
    ResponsiveContextConsumer,
} from './contexts';

// Outermost shell of core application post-authentication
function App() {
    // Renders the Layout (1st Layer) -> Admin (2nd Layer)
    return (
        <ResponsiveContextProvider>
            <BrowserRouter>
                <ResponsiveContextConsumer>
                    {(value: boolean) => <AppRouter responsive={value} />}
                </ResponsiveContextConsumer>
            </BrowserRouter>
        </ResponsiveContextProvider>
    );
}

// Exports for use by `./index.tsx`
export default App;
